









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { Mutation } from 'vuex-module-decorators';
import {Actions} from '@/ts/store/Constants';
import Order from '@/ts/Order';
import OrderPay from '@/components/User/Wallet/OrderPay.vue';

@Component({
    components: {
        OrderPay,
    },
})

export default class OrderDetails extends Vue {


    get date() {
       return this.order.momentDate.format('hh:mm a');
    }

    get showPayPage(): boolean {
        return this.$store.getters['OrderDetails/getShowPayPageStatus'];
    }

    get order(): Order {
        return this.$store.getters['UserUpcomingPayments/getOrder'];
    }

    get creditCards(): any {
       return this.$store.getters['CreditCards/getCreditCards'];
    }

    constructor() {
        super();
    }

    public toggleShowPayPageStatus(status: boolean) {
        this.$store.commit(Mutations.SET_SHOW_PAYMENT_PAGE_STATUS, status);
    }

    public created() {
        if (typeof this.$route.params.orderId !== 'undefined') {
            this.$store.dispatch(Actions.FETCH_ORDER_DETAILS, this.$route.params.orderId);
        }

        this.$store.dispatch(Actions.FETCH_USER_CREDIT_CARDS);
    }

    public mounted() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, 'StaffBackButton');
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('headers.order-detail', 'Order Detail'));
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }
}
